import { api } from '@/lib/api'
import type { CreateLoanPayload, LoanDetailResponse, LoanSchedule } from './types'

export const loanApi = {
  list: () => api.get<LoanSchedule[]>('/api/schedules/loan'),
  detail: (id: number) => api.get<LoanDetailResponse>(`/api/schedules/loan/${id}`),
  create: (body: CreateLoanPayload) =>
    api.post<{ id?: number; message?: string }>('/api/schedules/', body),
  update: (id: number, body: Partial<CreateLoanPayload>) =>
    api.put<{ id?: number; message?: string }>(`/api/schedules/${id}`, body),
  remove: (id: number) => api.del<{ message?: string }>(`/api/schedules/${id}`),
}
